// extracted by mini-css-extract-plugin
export default {"logosWrap":"logosWrap--dXk0x"};